// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"9ab3a5bf","723":"96c9768c","787":"e4e57e8e","909":"3f07f00d"}[chunkId] + ".chunk.js";
};